import React from 'react';
import moment from 'moment';

interface Shift {
  isCurrentShift: boolean;
  open: string;
  close: string;
}

interface ShiftInfoProps {
  currentShifts: Shift | null | undefined;
}

const ShiftInfo: React.FC<ShiftInfoProps> = ({ currentShifts }) => {
  if (!currentShifts) return <>Fermé </>; 

  return (
    <>
      {currentShifts.isCurrentShift ? "Fermé" : "Ouvert"} à{" "}
      {currentShifts.isCurrentShift
        ? moment(currentShifts.close, "HH:mm").format("HH:mm")
        : moment(currentShifts.open, "HH:mm").format("HH:mm")}
    </>
  );
};

export default ShiftInfo;



// Returns a friendly message depending on the shifts array
export const getRestaurantStatusMessage = (shifts: Shift[]) => {
  if (!shifts || shifts.length === 0) {
    return "Ce restaurant est actuellement fermé. Veuillez revenir plus tard.";
  }

  // Find the current shift
  const currentShift = shifts.find(shift => shift.isCurrentShift);

  if (currentShift) {
    const closeTime = moment(currentShift.close, "HH:mm:ss").format("HH:mm");
    return `Le restaurant est ouvert jusqu'à ${closeTime}.`;
  }

  // If no current shift, find the next shift today (or just pick the first one)
  const now = moment();
  const upcomingShift = shifts.find(shift => moment(shift.open, "HH:mm:ss").isAfter(now)) || shifts[0];
  const openTime = moment(upcomingShift.open, "HH:mm:ss").format("HH:mm");

  return `Ce restaurant est fermé pour le moment. Il ouvrira à ${openTime}.`;
};